<template>
    <div class="row team-member content-left-aligned">
        <div class="col-4 content-left-aligned d-none d-md-block">
            <img :src="this.getImage(member.image)">
        </div>
        <div class="col-12 col-md-8 content-left-aligned">
            <h3>{{ member.name }}</h3>
            <h4>{{ member.role }}</h4>
            <p v-html="member.bio">{{ member.bio }}</p>

            <!-- <ul class="social-media">
                <li>
                    <a href="#">
                        <img src="dist/img/social-media/twitter-icon.svg">
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="dist/img/social-media/dribbble-icon.svg">
                    </a>
                </li>
            </ul>-->
        </div>
    </div>
</template>

<script>
export default {
    name: "TeamMember",
    props: ["member"],
    methods: {
        getImage(image) {
            return require(`@/assets/img/mugshots/${image}`);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";
</style>
